<template>
  <v-container grid-list-md text-xs-left v-if="pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
          v-for="breadcrumb in breadcrumbs"
          :key="breadcrumb.name"
          :disabled="typeof breadcrumb.link === 'undefined'"
          :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-layout row>
      <v-flex xs12>
        <h1 class="text-xs-left ma-3">Отчёт мониторинга</h1>
      </v-flex>
    </v-layout>

    <v-layout row class="ml-3">
      <v-flex xs12 lg12 md12>
        <v-layout>
          <v-flex xs4 lg4 md4>
            <v-menu
              ref="startDateMenu"
              :close-on-content-click="false"
              v-model="startDateMenu"
              :return-value.sync="startDate"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
              class="mr-3"
            >
              <v-text-field
                slot="activator"
                v-model="startDateFormatted"
                label="Начальная дата"
                readonly
                outline
              ></v-text-field>
              <v-date-picker
                v-model="startDate"
                locale="ru"
                :first-day-of-week="1"
                @input="onInputStartDate"
              ></v-date-picker>
            </v-menu>
          </v-flex>

          <v-flex xs4 lg4 md4>
            <v-menu
              ref="endDateMenu"
              :close-on-content-click="false"
              v-model="endDateMenu"
              :return-value.sync="endDate"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
              class="mr-3"
            >
              <v-text-field
                slot="activator"
                v-model="endDateFormatted"
                label="Конечная дата"
                readonly
                outline
              ></v-text-field>
              <v-date-picker
                v-model="endDate"
                locale="ru"
                :first-day-of-week="1"
                @input="onInputEndDate"
              ></v-date-picker>
            </v-menu>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout row>
      <v-flex xs12>
        <v-btn
          color="primary"
          class="ml-3"
          @click="onGetReport"
        >
          Получить отчёт
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        breadcrumbs: [
          {name: 'Главная', link: '/'},
          {name: 'Отчёт мониторинга'}
        ],
        pageDataReady: {
          isReady: false
        },
        startDate: null,
        startDateFormatted: null,
        startDateMenu: false,
        endDate: null,
        endDateFormatted: null,
        endDateMenu: false
      }
    },
    beforeCreate () {
      this.$store.commit('setPageLoading', true)
    },
    created () {
      this.pageDataStatus()
      this.$store.commit('setPageTitle', 'Отчёт мониторинга')

      let date = new Date()
      this.endDate = this.$moment(date).format('YYYY-MM-DD')
      date.setDate(date.getDate() - 30)
      this.startDate = this.$moment(date).format('YYYY-MM-DD')
      this.startDateFormatted = this.formatDate(this.startDate)
      this.endDateFormatted = this.formatDate(this.endDate)
    },
    computed: {
    },
    methods: {
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}.${month}.${year}`
      },
      pageDataStatus () {
        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      onGetReport () {
        window.location.href = 'https://backendv2.producto.store:746/admin/monitoring/report_status' +
          '?access_token=' + this.$store.getters.accessToken +
          '&start_date=' + this.startDate +
          '&end_date=' + this.endDate
      },
      onInputStartDate () {
        this.$refs.startDateMenu.save(this.startDate)
        this.startDateFormatted = this.formatDate(this.startDate)
      },
      onInputEndDate () {
        this.$refs.endDateMenu.save(this.endDate)
        this.endDateFormatted = this.formatDate(this.endDate)
      }
    },
    watch: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Monitorings/MonitoringReport.vue